import React from 'react'
import CertificateBasedOn from './stages/CertificateBasedOn'
import { DividerHorizontal } from '../../shared/DividerHorizontal'
import CertificateDriverInfo from './stages/CertificateDriverInfo'
import CertificateRange from './stages/CertificateRange'
import CertificateExposure from './stages/CertificateExposure'
import CertificateExhibitor from './stages/CertificateExhibitor'
import CertificateOptions from './stages/CertificateOptions'
import CertificateReception from './stages/CertificateReception'
import CertificateCreateFor from './stages/CertificateCreateFor'

const CertificatesForm = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-p-6 tw-overflow-auto">
      <CertificateCreateFor />
      <DividerHorizontal />
      <CertificateBasedOn />
      <DividerHorizontal />
      <CertificateDriverInfo />
      <DividerHorizontal />
      <CertificateRange />
      <DividerHorizontal />
      <CertificateExposure />
      <DividerHorizontal />
      <CertificateReception />
      <DividerHorizontal />
      <CertificateExhibitor />
      <DividerHorizontal />
      <CertificateOptions />
    </div>
  )
}

export default CertificatesForm
